module.exports = __webpack_public_path__ + "static/img/20191008003.8560718.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/images/20191008003.jpg
// module id = 26iZ
// module chunks = 45